import React, { FC } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import ErrorBoundary from '@buyside/components/presentation/ErrorBoundary/errorBoundary';
import IdeaIndexPage from '@buyside/components/presentation/IdeaIndexPage/ideaIndexPage';

import { ideasUrl } from '@buyside/util/urlHelper';

const IdeaIndexPageRoot: FC = () => {
  return (
    <ErrorBoundary pageName="idea index">
      <Router basename={ideasUrl()}>
        <IdeaIndexPage isPublic={false} />
      </Router>
    </ErrorBoundary>
  );
};

export default IdeaIndexPageRoot;
